import Cookies from 'js-cookie'
import { requestLogin } from '../../api/api'

const user = {
    state: {
        user: '',
        VSystemId: '2ef5ac97d1d259d06309b71838f4e766',
        // VSystemId: '9189f194783a3ae44daf4e2e0baac71d',
        shopping: 0
    },
    mutations: {
        SET_SHOPPING: (state, length) => {
            state.shopping = length
        },
        ADD_SHOPPING: (state) => {
            state.shopping++
        }
    },
    actions: {
        // 用户名登录
        Login({ commit }, userInfo) {
            return new Promise((resolve, reject) => {
                requestLogin(userInfo).then(res => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        SetShopping({ commit }, length) {
            commit('SET_SHOPPING', length)
        },
        AddShopping({ commit }) {
            commit('ADD_SHOPPING')
        }
    }
}

export default user;


// WEBPACK FOOTER //
// ./src/store/modules/user.js